import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import LeadCaptureSection from "./components/LeadCaptureSection";
import ProblemSection from "./components/ProblemSection";
import ScienceSection from "./components/ScienceSection";
import CtaSection from "./components/CtaSection";
import FormulaSection from "./components/FormulaSection";
import IngredientsSection from "./components/IngredientsSection";
import SocialProofSection from "./components/SocialProofSection";
import LifestyleSection from "./components/LifestyleSection";
import ExtraContent from "./components/ExtraContent";
import SelfAssessment from "./components/SelfAssessment";
import GuaranteeSection from "./components/GuaranteeSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="relative">
      {/* Floating PDF Download Button */}
      <button
        onClick={() => window.print()}
        className="no-print fixed bottom-6 right-6 z-50 bg-primary-500 text-background-50 hover:bg-primary-600 px-5 py-3 rounded-full font-bold text-sm uppercase tracking-wide flex items-center gap-2 whitespace-nowrap cursor-pointer transition-colors shadow-lg btn-hover-lift"
        aria-label="Download page as PDF"
      >
        <i className="ri-file-pdf-line text-lg" />
        Save as PDF
      </button>

      <Header />
      <HeroSection />
      <LeadCaptureSection />
      <ProblemSection />
      <ScienceSection />
      <CtaSection text="Learn More About Joint Genesis" />
      <FormulaSection />
      <IngredientsSection />
      <SocialProofSection />
      <CtaSection text="Review Ingredients & Pricing" />
      <LifestyleSection />
      <ExtraContent />
      <SelfAssessment />
      <CtaSection text="Check Current Availability" />
      <GuaranteeSection />
      <FaqSection />
      <Footer />
    </div>
  );
}